import isEmpty from 'lodash/isEmpty';
import {
  IBuilder,
  IErrors,
  RowType,
} from '../../../../redux/slices/oldBuilder';
import { getCohortRowErrorsByQueryType } from '../getCohortRowErrorsByQueryType';
import {
  DateKindKey,
  ExpressionModeKey,
  QueryType,
} from '../../../../utils/apollo/graphqlSchema';
import { assertCondition } from '../../../../utils/types';
import { isEmptyEventCondition } from '../../../../utils/builder';
import { getBasicMeasureRowErrors } from '../../../../utils/builder/validation';
import { isNil } from 'lodash';
import { validateTimeWindow } from '../validateExecutionInput';

const validateQueryBuilder = (oldBuilderState: IBuilder): IErrors => {
  const {
    measures,
    trigger,
    selectedOptions,
    timeWindow,
    measureFormula,
    binning,
  } = oldBuilderState;

  assertCondition(selectedOptions?.type === QueryType.Expression);

  const { mode, dateKind } = selectedOptions;

  const errors: IErrors = {
    // validate cohorts
    ...getCohortRowErrorsByQueryType(oldBuilderState, QueryType.Expression),
  };

  // check measures
  measures.forEach((row, rowIndex) => {
    const basicMeasureErrors = getBasicMeasureRowErrors(row);

    if (!isEmpty(basicMeasureErrors)) {
      errors[RowType.measures] = {
        ...(errors?.[RowType.measures] ?? {}),
        [rowIndex]: {
          ...(errors?.[RowType.measures]?.[rowIndex] ?? {}),
          ...basicMeasureErrors,
        },
      };
    }
  });

  // check Trigger events in Impact Analysis mode
  if (mode === ExpressionModeKey.Impact && isEmptyEventCondition(trigger)) {
    errors.trigger = {
      events: true,
    };
  }

  if (!isNil(timeWindow) && dateKind === DateKindKey.Install) {
    validateTimeWindow(errors, timeWindow);
  }

  // check Histogram binning in Histogram mode
  if (mode === ExpressionModeKey.Histogram && !binning) {
    errors.footer = true;
  }

  if (!isNil(measureFormula) && !measureFormula.isValid) {
    errors.measureFormula = true;
  }

  return errors;
};

export default validateQueryBuilder;
